// stamped-widget.js
function initStamped() {
  StampedFn.init({
    apiKey: 'pubkey-Ql05uk7Hxp1170MBxtiWmHRy0c3l1A',
    sId: '11374'
  });
}
// Dynamically load the Stamped script
(function() {
  var script = document.createElement('script');
  script.src = "https://cdn1.stamped.io/files/widget.min.js";
  script.async = true;
  script.onload = initStamped;
  document.head.appendChild(script);
})();



// Salepify app - show modal one every 1.5 minutes
// document.addEventListener('DOMContentLoaded', function () {
//   if (window.location.pathname === '/cart') {
//     // localStorage.removeItem('salepifyLastShown');
//     return;
//   }   
//   const cartMoneyEl = document.querySelector('.site-header__cart .money');
//   if (cartMoneyEl) {
//     const rawText = cartMoneyEl.textContent.trim();
//     const numericValue = parseFloat(rawText.replace(/[^0-9.]/g, ''));

//     if (!isNaN(numericValue) && numericValue > 0) {
//       // console.log('Cart value is more than 0:', numericValue);
//       (function () {
//         const popupClass = 'salepify-fg-advanced-wrapper';
//         const popup = document.querySelector(`.${popupClass}`);
//         const lastShownKey = 'salepifyLastShown';
//         const now = Date.now();
//         const lastShown = parseInt(localStorage.getItem(lastShownKey), 10);
      
//         // Make sure the popup is hidden by default
//         if (popup) popup.style.display = 'none';
      
//         if (isNaN(lastShown)) {
          
//           // First visit: store timestamp and show popup
//           localStorage.setItem(lastShownKey, now);
//           if (popup) popup.style.display = 'flex';
//           // console.log("now " + now)
//           // console.log("whats in LS " + lastShown)
          
//         } else {
          
//           const timeSinceLastShown = now - lastShown;
//           // console.log("now " + now)
//           // console.log("whats in LS " + lastShown)
//           console.log("time diff " + timeSinceLastShown)
          
//           if (timeSinceLastShown >= 600000) {
//             // It's been more than a one and half minute → update timestamp & show
//             localStorage.setItem(lastShownKey, now);
//             if (popup) popup.style.display = 'flex';
//           }
          
//           // else: less than 1 min passed → do nothing
//         }
//       })();
//     }
//     else{
//       localStorage.removeItem(lastShownKey);
//       // console.log('Cart is empty – localStorage key cleared');
//     }
//   }
// });



// Keep checking until the widget checkbox exists

// v1
// const precheckInterval = setInterval(() => {
//   const checkbox = document.getElementById("sam_switch_btn_2");

//   if (checkbox) {
//     // Stop checking once found
//     clearInterval(precheckInterval);

//     // If not already checked, tick and trigger the app logic
//     if (!checkbox.checked) {
//       checkbox.checked = true;
//       if (typeof __SAM !== "undefined" && __SAM.widget?.toggleShippingProtection) {
//         __SAM.widget.toggleShippingProtection(checkbox);
//       }
//     }
//   }
// }, 200); 

// v2
const STORAGE_KEY = "pref_01";
const RESET_TIME = 10 * 24 * 60 * 60 * 1000;
const precheckInterval = setInterval(() => {
  const checkbox = document.getElementById("sam_switch_btn_2");

  if (checkbox) {
    clearInterval(precheckInterval);

    const saved = localStorage.getItem(STORAGE_KEY);
    let useSavedChoice = false;

    if (saved) {
      try {
        const data = JSON.parse(saved);

        if (Date.now() - data.time < RESET_TIME) {
          checkbox.checked = data.value;
          useSavedChoice = true;
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    // No saved choice, or saved choice has expired
    if (!useSavedChoice) {
      checkbox.checked = true;

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          value: true,
          time: Date.now()
        })
      );
    }

    // Trigger the widget logic
    if (
      typeof __SAM !== "undefined" &&
      __SAM.widget?.toggleShippingProtection
    ) {
      __SAM.widget.toggleShippingProtection(checkbox);
    }

    // Remember customer's future changes
    checkbox.addEventListener("change", () => {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          value: checkbox.checked,
          time: Date.now()
        })
      );
    });
  }
}, 200);



// Flashing DOCUMENT TITLE
document.addEventListener("DOMContentLoaded", function () {

  const originalTitle = document.title;
  const flashText = "Botanex | Coming Home";
  let interval = null;
  let showingFlash = false;

  function startFlashing() {
    if (interval) return; // prevent duplicate intervals

    interval = setInterval(function () {
      document.title = showingFlash
        ? originalTitle
        : flashText;

      showingFlash = !showingFlash;
    }, 4500);
  }

  function stopFlashing() {
    clearInterval(interval);
    interval = null;
    document.title = originalTitle; // restore original title
  }

  // Detect when user leaves or returns to the tab
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      startFlashing();
    } else {
      stopFlashing();
    }
  });

});




// // product page scroll down on reviews click
// const badge = document.querySelector(".stamped-product-reviews-badge");
// const reviewsSection = document.querySelector(
//   "#prod_info_tabs .f-tabs__header-group .f-tabs__nav:nth-of-type(3)"
// );
// const reviewsSectionMobile = document.querySelector(
//   "#prod_info_tabs .f-product-tabs__blocks .f-tabs__content:nth-of-type(3) .collapsible__button span"
// );

// if (badge && reviewsSection) {
//   badge.onclick = function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     const headerOffset = 30; // adjust for sticky header
//     const targetPosition =
//       reviewsSection.getBoundingClientRect().top + window.pageYOffset - headerOffset;

//     window.scrollTo({
//       top: targetPosition,
//       behavior: "smooth",
//     });

//     // Trigger animation
//     reviewsSection.click();
//     // reviewsSection.classList.add("review-highlight");
//     // setTimeout(() => {
//     //   reviewsSection.classList.remove("review-highlight");
//     // }, 2000);
//   };
// }

// window.addEventListener('load', function () {
//   setTimeout(function () {
//     const badgeText = document.querySelector('.stamped-badge-caption');
    
//     if (!reviewsSection || !badgeText || reviewsSection.querySelector('.review-count')) return;
    
//     const reviewCount = badgeText.getAttribute('data-reviews');
    
//     // Don't show anything if there are no reviews
//     if (!reviewCount || parseInt(reviewCount, 10) === 0) return;
    
//     const review = document.createElement('span');
//     review.className = 'review-count';
//     review.textContent = ` (${badgeText.textContent.trim()})`;
//     review.style.pointerEvents = 'none';
//     review.style.cursor = 'default';
//     review.style.marginLeft = '4px';
//     review.style.fontSize = '70%';
//     review.style.marginTop = '4px';
//     review.style.color = '#f0c713';
    
//     reviewsSection.appendChild(review);
//   }, 1000);
// });
// Product page: scroll to reviews on Stamped badge click
document.addEventListener("click", function (e) {
  const badge = e.target.closest(".stamped-product-reviews-badge");

  if (!badge) return;

  e.preventDefault();
  e.stopPropagation();

  // Desktop reviews tab
  const reviewsSection = document.querySelector(
    "#prod_info_tabs .f-tabs__header-group .f-tabs__nav:nth-of-type(3)"
  );

  // Mobile reviews button
  const reviewsSectionMobile = document.querySelector(
    "#prod_info_tabs .f-product-tabs__blocks .f-tabs__content:nth-of-type(3) .collapsible__button"
  );

  const isMobile = window.innerWidth <= 767;

  if (isMobile && reviewsSectionMobile) {

    // Open the reviews accordion first
    reviewsSectionMobile.click();

    // Wait for accordion to open before scrolling
    setTimeout(function () {
      const targetPosition =
        reviewsSectionMobile.getBoundingClientRect().top +
        window.pageYOffset -
        30;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }, 300);

  } else if (reviewsSection) {

    // Desktop
    const targetPosition =
      reviewsSection.getBoundingClientRect().top +
      window.pageYOffset -
      30;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth"
    });

    // Open reviews tab
    reviewsSection.click();
  }
});


// Add review count
window.addEventListener("load", function () {
  setTimeout(function () {

    const badgeText = document.querySelector(".stamped-badge-caption");

    if (!badgeText) return;

    const reviewCount = badgeText.getAttribute("data-reviews");

    // Don't show if there are no reviews
    if (!reviewCount || parseInt(reviewCount, 10) === 0) return;

    const reviewText = ` (${badgeText.textContent.trim()})`;

    const reviewsSection = document.querySelector(
      "#prod_info_tabs .f-tabs__header-group .f-tabs__nav:nth-of-type(3)"
    );

    const reviewsSectionMobile = document.querySelector(
      "#prod_info_tabs .f-product-tabs__blocks .f-tabs__content:nth-of-type(3) .collapsible__button span"
    );

    function addReviewCount(element) {

      if (!element || element.querySelector(".review-count")) return;

      const review = document.createElement("span");

      review.className = "review-count";
      review.textContent = reviewText;

      Object.assign(review.style, {
        pointerEvents: "none",
        cursor: "default",
        marginLeft: "4px",
        fontSize: "75%",
        marginTop: "4px",
        color: "#f0c713"
      });

      element.appendChild(review);
    }

    addReviewCount(reviewsSection);
    addReviewCount(reviewsSectionMobile);

  }, 1000);
});





document.addEventListener("DOMContentLoaded", () => {
  const paymentIcons = document.querySelector(".payment-icons");

  if (!paymentIcons) return;

  paymentIcons.insertAdjacentHTML(
    "beforeend",
    `
    <li class="payment-icon inline-flex" style="background:#fff;align-self:stretch;border:1px solid #dfdfdf;border-radius:4px;">
      <svg width="38" height="24" viewBox="0 0 300 135" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="pi-Zippay">
        <title id="pi-Zippay">Zip Pay</title>
        <path d="M300 20C300 8.9543 291.046 0 280 0H20C8.9543 0 0 8.95431 0 20V115C0 126.046 8.95431 135 20 135H280C291.046 135 300 126.046 300 115V20Z" fill="#FFFFFA"/>
        <path d="M117.043 46.5264L123.925 102.52H191.223L184.34 46.5264H117.043Z" fill="#AA8FFF"/>
        <path d="M136.241 25.159C140.533 29.1942 141.122 35.5407 137.556 39.3346C133.99 43.1285 127.619 42.9328 123.327 38.8977C119.035 34.8626 118.446 28.5161 122.012 24.7222C125.578 20.9284 131.949 21.1239 136.241 25.159Z" fill="#1A0826"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M261.751 66.6885C260.202 54.0955 250.31 46.4822 236.877 46.5264H192.13L199.012 102.52H219.151L217.779 91.3212H239.09C255.842 91.3212 263.521 80.8749 261.751 66.6885ZM236.899 75.6298L215.831 75.6519L214.171 62.2179L235.35 62.24C240.329 62.3064 242.874 65.095 243.295 68.9459C243.56 71.4026 242.431 75.6298 236.899 75.6298Z" fill="#1A0826"/>
        <path d="M46.9571 86.8728L48.8824 102.52H116.113L113.9 84.6153H82.5643L82.2766 82.38L111.156 62.218L109.231 46.5265H42L44.1909 64.4532H75.5934L75.8811 66.6886L46.9571 86.8728Z" fill="#1A0826"/>
      </svg>
    </li>
    `
  );
});



// console.log("override the newsletter form submission and redirect to Klaviyo");

// document.addEventListener("DOMContentLoaded", () => {
//   const form = document.querySelector(".newsletter-form__design-1 form.contact-form");

//   if (!form) return;

//   form.addEventListener("submit", function (e) {
//     e.preventDefault();
//     e.stopImmediatePropagation();

//     const email = form.querySelector('input[name="contact[email]"]').value.trim();

//     const url = new URL("https://manage.kmail-lists.com/subscriptions/subscribe");
//     url.searchParams.set("a", "UxLE5d");
//     url.searchParams.set("g", "YgtbEN");

//     if (email) {
//       url.searchParams.set("email", email);
//     }

//     // window.location.href = url.toString();
//     window.open(url.toString(), "_blank", "noopener,noreferrer");
//   }, true);
// });

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".newsletter-form__wrapper");
  if (!el) return;

  el.onclick = () => window.open(
    "https://manage.kmail-lists.com/subscriptions/subscribe?a=UxLE5d&g=YgtbEN",
    "_blank"
  );
});